import React from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
  hiddenInHtmlText: {
    display: 'block',
    fontSize: '0.9rem',
    lineHeight: '1em',
    backgroundColor: 'var(--color-neutral-400)',
    color: 'var(--text-color-main)',
    borderRadius: 'var(--border-radius-sm)',
    padding: '.3em 1em',
    width: 'fit-content',
    margin: '0 auto',
    position: 'relative',
    zIndex: 10
  }
}))

export const HiddenInHtmlLabel = ({ label = '(Hidden in HTML)' }) => {
  const classes = useStyles()

  return (
    <div className={classes.hiddenInHtmlText}>
      {label}
    </div>
  )
}
HiddenInHtmlLabel.propTypes = {
  label: PropTypes.string
}
